import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { projects } from "../mockdata";
import { ChevronDown } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileVideosOpen, setIsMobileVideosOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
  }, [isMenuOpen]);

  const handleNavigate = (id) => {
    navigate(`/projects/${id}`);
    setIsDropdownOpen(false);
  };

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="fixed top-0 left-0 right-0 bg-white z-50 shadow-md py-3">
        <div className="max-w-[1200px] mx-auto px-4 lg:px-8 flex justify-between items-center">

          {/* Logo */}
          <Link to="/">
            <img
              src="/images/logo.webp"
              alt="Logo"
              className="h-12 md:h-14 object-contain"
            />
          </Link>

          {/* ================= DESKTOP NAV (768px+) ================= */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8 font-medium">

            <Link to="/" className="nav-link">Home</Link>
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/services" className="nav-link">Services</Link>
            <Link to="/projects" className="nav-link">Projects</Link>
            <Link to="/clients" className="nav-link">Clients</Link>
            <Link to="/contact" className="nav-link">Contact</Link>

            {/* Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <button className="nav-link flex items-center gap-1">
                Project Videos  ▾
                {/* <ChevronDown className="w-4 h-4" /> */}
              </button>

              {isDropdownOpen && (
                <ul className="absolute top-full left-0 w-64 bg-white border rounded-md shadow-lg z-50 py-2">
                  {projects
                    .filter(
                      (project) =>
                        Array.isArray(project.videos) &&
                        project.videos.length > 0
                    )
                    .map((project) => (
                      <li
                        key={project.id}
                        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                        onClick={() =>
                          handleNavigate(`${project.id}?scroll=video`)
                        }
                      >
                        <img
                          src={project.image}
                          alt={project.title}
                          className="w-10 h-10 object-cover rounded"
                        />
                        <span className="truncate">{project.title}</span>
                      </li>
                    ))}
                </ul>
              )}
            </div>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <a
              href="/images/Milestone Associates Electrical & Mechanical Design Firm.pptx"
              download
              className="bg-red-600 text-white py-3 px-6 rounded-full text-sm font-semibold hover:bg-red-700 transition"
            >
              Company Profile
            </a>
          </div>

          {/* ================= MOBILE TOGGLE (Below 768px) ================= */}
          <button
            onClick={toggleMenu}
            className="md:hidden z-50"
          >
            {isMenuOpen ? (
              <span className="text-3xl text-gray-800">&times;</span>
            ) : (
              <div className="flex flex-col gap-1.5">
                <span className="w-6 h-0.5 bg-black"></span>
                <span className="w-6 h-0.5 bg-black"></span>
                <span className="w-6 h-0.5 bg-black"></span>
              </div>
            )}
          </button>
        </div>
      </header>

      {/* ================= MOBILE MENU ================= */}
      <nav
        className={`fixed top-0 right-0 h-full w-full bg-white transform transition-transform duration-300 z-40 ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full px-8 pt-24 pb-16">

          <ul className="flex flex-col gap-6 text-xl font-medium">

            <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
            <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
            <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
            <li><Link to="/projects" onClick={toggleMenu}>Projects</Link></li>
            <li><Link to="/clients" onClick={toggleMenu}>Clients</Link></li>
            <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>

            {/* Mobile Accordion */}
            <li>
              <button
                onClick={() => setIsMobileVideosOpen(!isMobileVideosOpen)}
                className="flex justify-between items-center w-full"
              >
                Project Videos
                <ChevronDown
                  className={`w-5 h-5 transition-transform ${
                    isMobileVideosOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  isMobileVideosOpen ? "max-h-96 mt-4" : "max-h-0"
                }`}
              >
                <ul className="space-y-3 mt-3">
                  {projects
                    .filter(
                      (project) =>
                        Array.isArray(project.videos) &&
                        project.videos.length > 0
                    )
                    .map((project) => (
                      <li
                        key={project.id}
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-red-600 cursor-pointer"
                        onClick={() => {
                          navigate(`/projects/${project.id}?scroll=video`);
                          setIsMenuOpen(false);
                          setIsMobileVideosOpen(false);
                        }}
                      >
                        <img
                          src={project.image}
                          alt={project.title}
                          className="w-8 h-8 object-cover rounded"
                        />
                        <span className="truncate">{project.title}</span>
                      </li>
                    ))}
                </ul>
              </div>
            </li>
          </ul>

          <div className="mt-auto pt-10">
            <Link
              to="/contact"
              onClick={toggleMenu}
              className="block text-center bg-red-600 text-white py-4 rounded-full font-semibold hover:bg-red-700 transition"
            >
              Inquire Now
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
















// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { projects } from "../mockdata"; // make sure the path is correct

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const navigate = useNavigate();

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleNavigate = (id) => {
//     navigate(`/projects/${id}`);
//     setIsDropdownOpen(false);
//   };

//   return (
//     <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur z-[1000] shadow-md py-3">
//       <div className="max-w-[1200px] mx-auto px-12 flex justify-between items-center">
//         <div className="logo">
//           <Link to="/" className="no-underline text-inherit flex items-center">
//             <img
//               src="/images/logo.webp"
//               alt="Milstone Associates Logo"
//               className="h-14 w-auto object-contain"
//             />
//           </Link>
//         </div>

//         {/* Desktop Nav */}
//         <nav className="hidden md:block">
//           <ul className="flex list-none m-0 p-0 gap-8 relative">
//             <li>
//               <Link
//                 to="/"
//                 className="no-underline text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-red-600 after:transition-all after:duration-300 hover:after:w-full"
//               >
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/about"
//                 className="no-underline text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-red-600 after:transition-all after:duration-300 hover:after:w-full"
//               >
//                 About
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/services"
//                 className="no-underline text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-red-600 after:transition-all after:duration-300 hover:after:w-full"
//               >
//                 Services
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/projects"
//                 className="no-underline text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-red-600 after:transition-all after:duration-300 hover:after:w-full"
//               >
//                 Projects
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/clients"
//                 className="no-underline text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-red-600 after:transition-all after:duration-300 hover:after:w-full"
//               >
//                 Clients
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/contact"
//                 className="no-underline text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-red-600 after:transition-all after:duration-300 hover:after:w-full"
//               >
//                 Contact
//               </Link>
//             </li>

//              <li
//   className="relative"
//   onMouseEnter={() => setIsDropdownOpen(true)}
//   onMouseLeave={() => setIsDropdownOpen(false)}
// >
//   <button className="text-gray-800 font-medium text-base relative hover:text-red-600 transition-colors duration-300">
//     Project Videos ▾
//   </button>

//   {isDropdownOpen && (
//     <ul className="absolute top-full left-0 w-64 bg-white border rounded-md shadow-lg z-50 py-2">
//       {projects
//         .filter((project) => project.videos)
//         .map((project) => (
//           <li
//             key={project.id}
//             className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
//             onClick={() => handleNavigate(`${project.id}?scroll=video`)}
//           >
//             <img
//               src={project.image}
//               alt={project.title}
//               className="w-10 h-10 object-cover rounded"
//             />
//             <span className="truncate">{project.title}</span>
//           </li>
//         ))}
//     </ul>
//   )}
// </li>

//           </ul>
//         </nav>

//         {/* Desktop CTA */}
//         <div className="hidden md:flex items-center">
//           <a
//             href="/images/Milestone Associates Electrical & Mechanical Design Firm.pptx"
//             download
//             className="ml-4 bg-red-600 text-white py-3 px-6 rounded-full no-underline font-semibold text-sm transition-all duration-300 hover:bg-white-800 hover:-translate-y-0.5 hover:shadow-lg"
//           >
//             Company Profile
//           </a>
//         </div>

//         {/* Mobile Menu Button */}
//         <button
//           type="button"
//           className="flex flex-col gap-1.5 cursor-pointer md:hidden z-20"
//           onClick={toggleMenu}
//           aria-label="Toggle navigation"
//         >
//           <span className="w-6 h-0.5 bg-[#1a365d] transition-all duration-300"></span>
//           <span className="w-6 h-0.5 bg-[#1a365d] transition-all duration-300"></span>
//           <span className="w-6 h-0.5 bg-[#1a365d] transition-all duration-300"></span>
//         </button>

//         {/* Mobile Nav */}
//         <nav
//           className={`fixed inset-0 md:hidden bg-white/95 backdrop-blur-sm z-[999] transform transition-transform duration-300 ${
//             isMenuOpen ? "translate-y-0" : "-translate-y-full"
//           }`}
//         >
//           <div className="max-w-[1200px] mx-auto h-full flex flex-col px-8 pt-6 pb-8">
//             <div className="flex items-center justify-between mb-8">
//               <Link
//                 to="/"
//                 className="no-underline text-inherit flex items-center"
//                 onClick={() => setIsMenuOpen(false)}
//               >
//                 <img
//                   src="/images/logo.webp"
//                   alt="Milstone Associates Logo"
//                   className="h-12 w-auto object-contain"
//                 />
//               </Link>
//               <button
//                 type="button"
//                 className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-700 text-xl"
//                 onClick={toggleMenu}
//                 aria-label="Close navigation"
//               >
//                 ×
//               </button>
//             </div>

//             <ul className="flex flex-col gap-4 text-lg font-medium flex-1">
//               <li>
//                 <Link
//                   to="/"
//                   className="block no-underline text-gray-900 hover:text-red-600"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="block no-underline text-gray-900 hover:text-red-600"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   About
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services"
//                   className="block no-underline text-gray-900 hover:text-red-600"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Services
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/projects"
//                   className="block no-underline text-gray-900 hover:text-red-600"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Projects
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/clients"
//                   className="block no-underline text-gray-900 hover:text-red-600"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Clients
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="block no-underline text-gray-900 hover:text-red-600"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   Contact
//                 </Link>
//               </li>
//               <li className="pt-2">
//                 <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">
//                   Project Videos
//                 </p>
//                 <div className="max-h-40 overflow-y-auto pr-2">
//                   <ul className="space-y-2">
//                     {projects
//                       .filter(
//                         (project) =>
//                           Array.isArray(project.videos) &&
//                           project.videos.length > 0
//                       )
//                       .map((project) => (
//                         <li
//                           key={project.id}
//                           className="flex items-center gap-2 text-sm text-gray-700 hover:text-red-600 cursor-pointer"
//                           onClick={() => {
//                             navigate(`/projects/${project.id}?scroll=video`);
//                             setIsMenuOpen(false);
//                           }}
//                         >
//                           <img
//                             src={project.image}
//                             alt={project.title}
//                             className="w-8 h-8 object-cover rounded"
//                           />
//                           <span className="truncate">{project.title}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 </div>
//               </li>
//             </ul>

//             <div className="mt-6 flex flex-col gap-3">
//               <Link
//                 to="/contact"
//                 onClick={() => setIsMenuOpen(false)}
//                 className="block text-center no-underline bg-red-600 text-white py-3 rounded-full font-semibold text-sm hover:bg-red-700"
//               >
//                 Inquire Now
//               </Link>
//               <a
//                 href="/images/Milestone Associates Electrical & Mechanical Design Firm.pptx"
//                 download
//                 className="block text-center no-underline border border-gray-900 text-gray-900 py-3 rounded-full font-semibold text-sm hover:bg-gray-900 hover:text-white"
//                 onClick={() => setIsMenuOpen(false)}
//               >
//                 Company Profile
//               </a>
//             </div>
//           </div>
//         </nav>
//       </div>
//     </header>
//   );
// };

// export default Header;
